import { createWithEqualityFn } from 'zustand/traditional'
import { persist, createJSONStorage } from 'zustand/middleware'
import axios from 'axios'

interface ProfileStore {
	profile?: any
	userProfile?: any
	updateProgress?: number
	setProfile: (profile: any) => void
	setUserProfile: (profile: any) => void
	setUpdateProgress: (progress: number) => void
	getProfile: () => Promise<{ success: boolean; data: any }>
	getUserProfile: () => Promise<{ success: boolean; data: any }>
	updateProfile: (profile: any) => Promise<{ success: boolean; data: any }>
	addGalleryImage: (image: any) => Promise<{ success: boolean; data: any }>
	removeGalleryImage: (imageId: string) => Promise<{ success: boolean; data: any }>
	clearState: () => void
}

export const API_SLUG = '/suppliers/profile'

export const useProfileStore = createWithEqualityFn(
	persist<ProfileStore>(
		set => ({
			profile: undefined,
			userProfile: undefined,
			updateProgress: 0,
			setProfile: (profile: any) => set({ profile }),
			setUserProfile: (profile: any) => set({ userProfile: profile }),
			setUpdateProgress: (progress: number) => set({ updateProgress: progress }),
			getProfile: async () => {
				try {
					const res = await axios.get(API_SLUG)
					set({ profile: res.data })

					return { success: true, data: res.data }
				} catch (err: any) {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				}
			},
			getUserProfile: async () => {
				try {
					const res = await axios.get(`/suppliers/user-profile`)
					set({ userProfile: res.data })

					return { success: true, data: res.data }
				} catch (err: any) {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				}
			},
			updateProfile: async (data: any) => {
				try {
					const formData = new FormData()
					Object.keys(data).forEach(key => {
						if (data[key] !== undefined) {
							formData.append(key, data[key])
						}
					})

					const res = await axios({
						method: 'PATCH',
						maxBodyLength: Infinity,
						url: API_SLUG,
						data: formData,
						headers: {
							'Content-Type': 'multipart/form-data',
						},
						onUploadProgress: progressEvent => {
							const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
							set({ updateProgress: progress })
						},
					})

					return { success: true, data: res.data }
				} catch (err: any) {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				}
			},
			addGalleryImage: async (image: any) => {
				try {
					const formData = new FormData()
					formData.append('image', image)

					const res = await axios.post(`${API_SLUG}/gallery-image`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
							charset: 'utf-8',
						},
					})

					return { success: true, data: res.data }
				} catch (err: any) {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				}
			},
			removeGalleryImage: async imageId => {
				try {
					const res = await axios.delete(`${API_SLUG}/gallery-image/${imageId}`)

					return { success: true, data: res.data }
				} catch (err: any) {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				}
			},
			clearState: () => {
				set({
					profile: undefined,
				})
			},
		}),
		{
			name: 'kumopack-buyer-user-storage',
			storage: createJSONStorage(() => localStorage),
		}
	),
	Object.is
)
